// operacao da importacao
export enum OperacaoApontamentosImportacaoEnum {
	SOMAR = 0,
    SOBREPOR = 1,
    INCLUIR = 2,
    IGNORAR = 3,
}
